import React from 'react';
import FormGroup from "reactstrap/es/FormGroup";
import Input from "reactstrap/es/Input";

class RegionItem extends React.Component {

    constructor(props) {
        super(props);

    }
    
    updateName = (e) => {
        if (this.props.onNameChange) {
            var {feature} = this.props;
            feature.properties["name"] = e.target.value;
            this.props.onNameChange(feature);
        }
    }

    updateCalendar = (e) => {
        if (this.props.onCalendarChange) {
            var {feature} = this.props;
            feature.properties["calendly_url"] = e.target.value;
            this.props.onCalendarChange(feature);
        }
    }

    updateSelfBook = (e) => {
        if (this.props.onSelfBookChange) {
            var {feature} = this.props;
            feature.properties["self_book_url"] = e.target.value;
            this.props.onSelfBookChange(feature);
        }
    }

    updateSmallSystem = (e) => {
        if (this.props.onSmallSystemChange) {
            var {feature} = this.props;
            feature.properties["small_system"] = e.target.value;
            this.props.onSmallSystemChange(feature);
        }
    }

    updateLargeSystem = (e) => {
        if (this.props.onLargeSystemChange) {
            var {feature} = this.props;
            feature.properties["large_system"] = e.target.value;
            this.props.onLargeSystemChange(feature);
        }
    }

  updateSales = (e) => {
        if (this.props.onSalesAreaChange) {
            var {feature} = this.props;
            feature.properties["sales_area"] = e.target.value;
            this.props.onCalendarChange(feature);
        }
    }

    _onShowDeleted = (id) => {
        if (this.props.onShowDeleted) {
            this.props.onShowDeleted(id);
        }
    }

    _onSaveClick = () => {
        if (this.props.onSaveClick) {
            this.props.onSaveClick(this.props.feature)
        }
    }

    _onDeleteClick = () => {
        if (this.props.onDeleteClick) {
            this.props.onDeleteClick(this.props.feature)
        }
    }

    render() {
        const {feature, deleted, selected} = this.props;
        return (
            <>
                <div className={`region-item--item--wrapper ${selected ? 'region-item--selected' : ''}`}>
                    <div>
                        <FormGroup>
                            <label>Region Name:</label>
                            <Input onChange={this.updateName} name={`name`} value={this.props.feature.properties.name} type="text" />
                        </FormGroup>
                    </div>
                    <div>
                        <FormGroup>
                            <label>Sales Area:</label>
                            <Input onChange={this.updateSales} name={`sales`} value={this.props.feature.properties.sales_area || ''} type="text" />
                        </FormGroup>
                    </div>
                    <div>
                        <FormGroup>
                            <label>Calendly URL:</label>
                            <Input onChange={this.updateCalendar} name={`calendar`} value={this.props.feature.properties.calendly_url || ''} type="text" />
                        </FormGroup>
                    </div>
                    <div>
                        <FormGroup>
                            <label>Self Book URL:</label>
                            <Input onChange={this.updateSelfBook} name={`self-book`} value={this.props.feature.properties.self_book_url || ''} type="text" />
                        </FormGroup>
                    </div>
                    <div>
                        <FormGroup>
                            <label>Small System (&lt;7kW) Install Link:</label>
                            <Input onChange={this.updateSmallSystem} name={`small-system-link`} value={this.props.feature.properties.small_system || ''} type="text" />
                        </FormGroup>
                    </div>
                    <div>
                        <FormGroup>
                            <label>Large System (&gt;7kW) Install Link:</label>
                            <Input onChange={this.updateLargeSystem} name={`large-system-link`} value={this.props.feature.properties.large_system || ''} type="text" />
                        </FormGroup>
                    </div>
                    <div>
                        {deleted && '- Deleted ' &&
                        <React.Fragment>
                            <div>Region has been deleted</div>
                            <div><span onClick={() => this._onShowDeleted(feature.id)}> Display again on map</span></div>

                        </React.Fragment>
                        }
                    </div>
                    <div className={`region-item--region-action--wrapper`}>
                        <div><i className={`tim-icons icon-check-2`} style={{paddingRight: "25px"}} onClick={this._onSaveClick}></i></div>
                        <div><i className={`tim-icons icon-simple-remove`} onClick={this._onDeleteClick}></i></div>

                    </div>
                </div>
            </>
        )
    }
}
export default RegionItem;
